<a href="https://bit.ly/2j8iHVf" target="_blank" rel="nofollow noreferrer noopener">
  <div class="card place-nominate-box">

    <div class="card-space">
      <picture>
        <source srcset="/images/discover/place-nominate-box/croissant-question.webp" type="image/webp">
        <img src="/images/discover/place-nominate-box/croissant-question.png" alt="Croissant question" class="img-responsive"/>
      </picture>
    </div>

    <div class="card-body">
      <div class="card-title">
        <h4>Know of a great spot?</h4>
      </div>

      <div class="card-subtitle">
        <div class="hide-md hide-lg"><small>Let us know by nominating a space!</small></div>
        <div class="hide-sm hide-xl hide-xxl"><small>Recommend a space!</small></div>
      </div>
    </div>
  </div>
</a>
